var render, staticRenderFns
import script from "./VHeadline.vue?vue&type=script&lang=js&"
export * from "./VHeadline.vue?vue&type=script&lang=js&"
import style0 from "./VHeadline.vue?vue&type=style&index=0&id=248b750e&scoped=true&lang=scss&"
import style1 from "./VHeadline.vue?vue&type=style&index=1&id=248b750e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b750e",
  null
  
)

export default component.exports